import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import React from 'react';
import stylesheet from "../detail-container.stylesheet";
interface IProps {
  msg?: any,
  align?:any
  classes: ClassNameMap,
}
const EmptyCardComponent: React.FC<IProps> = ({ msg, align,classes }) => {
  return (<>
    <Grid container direction="column" data-testid='empty-card'>
      <Box className={classes.customCard}>
        <Card variant="outlined" className={classes.fullWidth}>
          <CardContent className={classes.emptyCardContent}>
            <Typography color="textSecondary" align={align?align:'center'} className={classes.customCard1}>{msg || `No data.`}</Typography>
          </CardContent>
        </Card>
      </Box>
    </Grid>
  </>)
}


export default withStyles(stylesheet)(EmptyCardComponent);